/* eslint-disable react/destructuring-assignment */
import React from 'react';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { useHistory, useLocation, useRouteMatch } from 'react-router';
import Header from './Header';
import Hidden from '../../../../components/atomic/Hidden';
import useDashboardLinkPrefix from '../../../../hooks/useDashboardLinkPrefix';

export function SmallScreenHeader(props) {
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();
  const financialsUrl = `${match.url}/financials`;

  const isFinancialsRoute = location.pathname === financialsUrl;
  const activeTabIndex = isFinancialsRoute ? 1 : 0;

  const dashboardLinkPrefix = useDashboardLinkPrefix();
  const notificationsLink = `${dashboardLinkPrefix}/notifications`;

  const setActiveTabIndex = (tabIndex) => {
    history.push(tabIndex === 0 ? match.url : financialsUrl);
  };

  return (
    <Hidden mdUp>
      <Header
        property={props.activeProperty}
        className={props.classes.header}
        fetching={props.fetchingProperties}
        error={props.fetchingPropertiesError}
        notificationsLink={notificationsLink}
      >
        <div className={props.classes.tabContainer}>
          <Tabs
            variant="fullWidth"
            textColor="secondary"
            value={activeTabIndex}
            indicatorColor="secondary"
            onChange={(event, value) => setActiveTabIndex(value)}
            className={props.classes.tabWrapper}
            TabIndicatorProps={{
              className: props.classes.tabIndicator,
            }}
          >
            <Tab label="Oversikt" className={props.classes.tab} />
            <Tab label="Verdi" className={props.classes.tab} />
          </Tabs>
        </div>
      </Header>
    </Hidden>
  );
}
